 (function () {
    const cartFetch = window.__nativeFetch || window.fetch

    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function getCart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer')
    }

    function addUpsellItem(button) {
      if (button.getAttribute('aria-disabled') === 'true') return

      const item = button.closest('.cart-drawer-upsell-list-item')
      const variantField = item && item.querySelector('.cart-upsell-variant-id')
      const variantId = variantField && variantField.value
      if (!variantId) return

      const cart = getCart()
      const spinner = button.querySelector('.loading__spinner')

      window.pauseAllMedia()

      button.setAttribute('aria-disabled', 'true')
      button.classList.add('loading')
      if (spinner) spinner.classList.remove('hidden')

      const formData = new FormData()
      formData.append('id', variantId)
      formData.append('quantity', 1)

      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id))
        formData.append('sections_url', window.location.pathname + (window.location.search || '?'))
        cart.setActiveElement(document.activeElement)
      }

      cartFetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error(response.errors || response.description || response.message)
            return
          }
          if (cart) {
            cart.renderContents(response)
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty')
          } else {
            window.location = window.routes.cart_url
          }
        })
        .catch((e) => console.error(e))
        .finally(() => {
          button.classList.remove('loading')
          button.removeAttribute('aria-disabled')
          if (spinner) spinner.classList.add('hidden')
        })
    }

    document.addEventListener('click', function (event) {
      const button = event.target.closest('.cart-upsell-add-btn')
      if (!button) return
      event.preventDefault()
      addUpsellItem(button)
    })
  })();
